module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/babel-runtime/core-js/object/keys.js
// module id = 20
// module chunks = 0